import React, { FC } from 'react'
import { SuggestionForm } from '@features/tsp/suggest'
import { BottomSheet } from '@shared/ui/molecules'
import SuggestionSentContent from './SuggestionSentContent'
import SuggestionNotSentContent from './SuggestionNotSentContent'

interface SuggestTspModalMobileProps {
  open: boolean
  onClose: () => void
}

const SuggestTspModalMobile: FC<SuggestTspModalMobileProps> = ({ open, onClose }) => (
  <BottomSheet open={open} onClose={onClose}>
    <SuggestionForm
      renderContent={({ isSuggestionSent }) =>
        isSuggestionSent ? <SuggestionSentContent onClose={onClose} /> : <SuggestionNotSentContent onClose={onClose} />
      }
    />
  </BottomSheet>
)

export default SuggestTspModalMobile
